import { type HTMLAttributes, forwardRef } from 'react'
import { iconBadgeVariants } from './IconBadge.variants'

export interface IconBadgeProps extends HTMLAttributes<HTMLDivElement> {
  rounded?: boolean
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
}

export const IconBadge = forwardRef<HTMLDivElement, IconBadgeProps>(
  ({ rounded, accentColor, className, children, ...props }, ref) => {
    return (
      <div className={iconBadgeVariants({ rounded, accentColor, className })} ref={ref} {...props}>
        <span className="w-[22px] h-[22px] flex items-center justify-center drop-shadow-[0_0_2px_rgba(0,0,0,0.25)] [&>svg]:w-full [&>svg]:h-full">{children}</span>
      </div>
    )
  }
)

IconBadge.displayName = 'IconBadge'
